import $ from 'jquery';
import 'jquery.cookie';
import toastr from "toastr/toastr";
import {markMessagesRead} from "./notifications";
import QRCode from "qrcode";

const ACTIVE_MENU_ITEM = 'active-item';
const MOBILE_ACTIVE_MENU_ITEM = 'mobile-active-item';
const TABLET_ACTIVE_MENU_ITEM = 'tablet-active-item';
const TEXT_WHITE = 'text-white';
export const INSTANT_LINK = '/instant';
const BALANCE_HISTORY_LINK = '/balance-history';
const LOAN_HISTORY_LINK = '/loan-history';
const DEPOSIT_HISTORY_LINK = '/deposit-history';
const LOAN_TERMS = '/loan-terms';
const DEPOSIT_TERMS = '/deposit-terms';
const ACCOUNT_SETTINGS_LINK = '/account-settings';
const AUTH_HISTORY_LINK = '/authorization-history';
const SUPPORT_LINK = '/help';
const NOTIFICATIONS_LINK = '/notifications';
const PARTNER_LINK = '/partner';
export const DEPOSITS_LINK = '/deposits';

const RU_LOCALE = 'ru',
    EN_LOCALE = 'en';

const RU_FLAG = '/images/icons/ru.png',
    EN_FLAG = '/images/icons/en.png';

const NON_VISIBLE = 'd-none';

const M_INSTANT = $('#menu-instant');
const M_HISTORY = $('#menu-history');
const M_CONDITIONS = $('#menu-conditions');
const M_SETTINGS = $('#menu-settings');
const M_SUPPORT = $('#menu-support');
const M_NOTIFICATIONS = $('#menu-notifications');
const M_PARTNER = $('#menu-partner');
const M_DEPOSIT = $('#menu-deposit');

const MM_INSTANT = $('#mobile-menu-instant');
const MM_SETTINGS = $('#mobile-menu-settings');
const MM_HISTORY = $('#mobile-menu-history');
const MM_CONDITIONS = $('#mobile-menu-conditions');
const MM_SUPPORT = $('#mobile-menu-support');
const MM_NOTIFICATIONS = $('#mobile-menu-notifications');
const MM_PARTNER = $('#mobile-menu-partner');
const MM_DEPOSIT = $('#mobile-menu-deposit');

const TM_INSTANT = $('#tablet-menu-instant');
const TM_SETTINGS = $('#tablet-menu-settings');
const TM_NOTIFICATIONS = $('#tablet-menu-notifications');
const TM_SUPPORT = $('#tablet-menu-support');
const TM_HISTORY = $('#tablet-menu-history');
const TM_CONDITIONS = $('#tablet-menu-conditions');
const TM_PARTNER = $('#tablet-menu-partner');
const TM_DEPOSIT = $('#tablet-menu-deposit');

export const TOASTR_INFO = 'info';
export const TOASTR_SUCCESS = 'success';
export const TOASTR_ERROR = 'error';

const menuCurrentLink = () => {
    const currentRoute = window.location.pathname;
    if (currentRoute === INSTANT_LINK) {
        M_INSTANT.addClass(ACTIVE_MENU_ITEM);
        M_SETTINGS.removeClass(ACTIVE_MENU_ITEM);
        M_HISTORY.removeClass(ACTIVE_MENU_ITEM);
        M_SUPPORT.removeClass(ACTIVE_MENU_ITEM);
        M_NOTIFICATIONS.removeClass(ACTIVE_MENU_ITEM);
        M_CONDITIONS.removeClass(ACTIVE_MENU_ITEM);
        M_PARTNER.removeClass(ACTIVE_MENU_ITEM);
        M_DEPOSIT.removeClass(ACTIVE_MENU_ITEM);

        MM_INSTANT.addClass(TEXT_WHITE);
        MM_INSTANT.parent().addClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_SETTINGS.removeClass(TEXT_WHITE);
        MM_SETTINGS.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_HISTORY.removeClass(TEXT_WHITE);
        MM_HISTORY.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_SUPPORT.removeClass(TEXT_WHITE);
        MM_SUPPORT.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_NOTIFICATIONS.removeClass(TEXT_WHITE);
        MM_NOTIFICATIONS.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_CONDITIONS.removeClass(TEXT_WHITE);
        MM_CONDITIONS.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_PARTNER.removeClass(TEXT_WHITE);
        MM_PARTNER.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_DEPOSIT.removeClass(TEXT_WHITE);
        MM_DEPOSIT.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);

        TM_INSTANT.addClass(TABLET_ACTIVE_MENU_ITEM);
        TM_SETTINGS.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_HISTORY.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_SUPPORT.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_NOTIFICATIONS.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_CONDITIONS.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_PARTNER.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_DEPOSIT.removeClass(TABLET_ACTIVE_MENU_ITEM);
    }
    if (currentRoute === BALANCE_HISTORY_LINK || currentRoute === LOAN_HISTORY_LINK || currentRoute === DEPOSIT_HISTORY_LINK) {
        M_HISTORY.addClass(ACTIVE_MENU_ITEM);
        M_SETTINGS.removeClass(ACTIVE_MENU_ITEM);
        M_INSTANT.removeClass(ACTIVE_MENU_ITEM);
        M_SUPPORT.removeClass(ACTIVE_MENU_ITEM);
        M_NOTIFICATIONS.removeClass(ACTIVE_MENU_ITEM);
        M_CONDITIONS.removeClass(ACTIVE_MENU_ITEM);
        M_PARTNER.removeClass(ACTIVE_MENU_ITEM);
        M_DEPOSIT.removeClass(ACTIVE_MENU_ITEM);

        MM_HISTORY.addClass(TEXT_WHITE);
        MM_HISTORY.parent().addClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_SETTINGS.removeClass(TEXT_WHITE);
        MM_SETTINGS.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_INSTANT.removeClass(TEXT_WHITE);
        MM_INSTANT.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_SUPPORT.removeClass(TEXT_WHITE);
        MM_SUPPORT.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_NOTIFICATIONS.removeClass(TEXT_WHITE);
        MM_NOTIFICATIONS.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_CONDITIONS.removeClass(TEXT_WHITE);
        MM_CONDITIONS.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_PARTNER.removeClass(TEXT_WHITE);
        MM_PARTNER.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_DEPOSIT.removeClass(TEXT_WHITE);
        MM_DEPOSIT.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);

        TM_HISTORY.addClass(TABLET_ACTIVE_MENU_ITEM);
        TM_INSTANT.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_SETTINGS.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_SUPPORT.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_NOTIFICATIONS.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_CONDITIONS.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_PARTNER.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_DEPOSIT.removeClass(TABLET_ACTIVE_MENU_ITEM);
    }
    if (currentRoute === LOAN_TERMS || currentRoute === DEPOSIT_TERMS) {
        M_CONDITIONS.addClass(ACTIVE_MENU_ITEM);
        M_INSTANT.removeClass(ACTIVE_MENU_ITEM);
        M_HISTORY.removeClass(ACTIVE_MENU_ITEM);
        M_SUPPORT.removeClass(ACTIVE_MENU_ITEM);
        M_NOTIFICATIONS.removeClass(ACTIVE_MENU_ITEM);
        M_SETTINGS.removeClass(ACTIVE_MENU_ITEM);
        M_PARTNER.removeClass(ACTIVE_MENU_ITEM);
        M_DEPOSIT.removeClass(ACTIVE_MENU_ITEM);

        MM_CONDITIONS.addClass(TEXT_WHITE);
        MM_CONDITIONS.parent().addClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_INSTANT.removeClass(TEXT_WHITE);
        MM_INSTANT.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_HISTORY.removeClass(TEXT_WHITE);
        MM_HISTORY.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_SUPPORT.removeClass(TEXT_WHITE);
        MM_SUPPORT.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_NOTIFICATIONS.removeClass(TEXT_WHITE);
        MM_NOTIFICATIONS.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_SETTINGS.removeClass(TEXT_WHITE);
        MM_SETTINGS.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_PARTNER.removeClass(TEXT_WHITE);
        MM_PARTNER.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_DEPOSIT.removeClass(TEXT_WHITE);
        MM_DEPOSIT.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);

        TM_CONDITIONS.addClass(TABLET_ACTIVE_MENU_ITEM);
        TM_INSTANT.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_HISTORY.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_SUPPORT.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_NOTIFICATIONS.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_SETTINGS.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_PARTNER.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_DEPOSIT.removeClass(TABLET_ACTIVE_MENU_ITEM);
    }
    if (currentRoute === ACCOUNT_SETTINGS_LINK || currentRoute === AUTH_HISTORY_LINK) {
        M_SETTINGS.addClass(ACTIVE_MENU_ITEM);
        M_INSTANT.removeClass(ACTIVE_MENU_ITEM);
        M_HISTORY.removeClass(ACTIVE_MENU_ITEM);
        M_SUPPORT.removeClass(ACTIVE_MENU_ITEM);
        M_CONDITIONS.removeClass(ACTIVE_MENU_ITEM);
        M_NOTIFICATIONS.removeClass(ACTIVE_MENU_ITEM);
        M_PARTNER.removeClass(ACTIVE_MENU_ITEM);
        M_DEPOSIT.removeClass(ACTIVE_MENU_ITEM);

        MM_SETTINGS.addClass(TEXT_WHITE);
        MM_SETTINGS.parent().addClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_INSTANT.removeClass(TEXT_WHITE);
        MM_INSTANT.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_HISTORY.removeClass(TEXT_WHITE);
        MM_HISTORY.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_SUPPORT.removeClass(TEXT_WHITE);
        MM_SUPPORT.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_CONDITIONS.removeClass(TEXT_WHITE);
        MM_CONDITIONS.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_NOTIFICATIONS.removeClass(TEXT_WHITE);
        MM_NOTIFICATIONS.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_PARTNER.removeClass(TEXT_WHITE);
        MM_PARTNER.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_DEPOSIT.removeClass(TEXT_WHITE);
        MM_DEPOSIT.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);

        TM_SETTINGS.addClass(TABLET_ACTIVE_MENU_ITEM);
        TM_INSTANT.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_HISTORY.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_SUPPORT.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_CONDITIONS.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_NOTIFICATIONS.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_PARTNER.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_DEPOSIT.removeClass(TABLET_ACTIVE_MENU_ITEM);
    }
    if (currentRoute === SUPPORT_LINK) {
        M_SUPPORT.addClass(ACTIVE_MENU_ITEM);
        M_SETTINGS.removeClass(ACTIVE_MENU_ITEM);
        M_HISTORY.removeClass(ACTIVE_MENU_ITEM);
        M_INSTANT.removeClass(ACTIVE_MENU_ITEM);
        M_CONDITIONS.removeClass(ACTIVE_MENU_ITEM);
        M_NOTIFICATIONS.removeClass(ACTIVE_MENU_ITEM);
        M_PARTNER.removeClass(ACTIVE_MENU_ITEM);
        M_DEPOSIT.removeClass(ACTIVE_MENU_ITEM);

        MM_SUPPORT.addClass(TEXT_WHITE);
        MM_SUPPORT.parent().addClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_SETTINGS.removeClass(TEXT_WHITE);
        MM_SETTINGS.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_HISTORY.removeClass(TEXT_WHITE);
        MM_HISTORY.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_INSTANT.removeClass(TEXT_WHITE);
        MM_INSTANT.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_CONDITIONS.removeClass(TEXT_WHITE);
        MM_CONDITIONS.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_NOTIFICATIONS.removeClass(TEXT_WHITE);
        MM_NOTIFICATIONS.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_PARTNER.removeClass(TEXT_WHITE);
        MM_PARTNER.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_DEPOSIT.removeClass(TEXT_WHITE);
        MM_DEPOSIT.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);

        TM_SUPPORT.addClass(TABLET_ACTIVE_MENU_ITEM);
        TM_SETTINGS.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_HISTORY.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_INSTANT.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_CONDITIONS.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_NOTIFICATIONS.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_PARTNER.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_DEPOSIT.removeClass(TABLET_ACTIVE_MENU_ITEM);
    }
    if (currentRoute === NOTIFICATIONS_LINK) {
        M_NOTIFICATIONS.addClass(ACTIVE_MENU_ITEM);
        M_SETTINGS.removeClass(ACTIVE_MENU_ITEM);
        M_HISTORY.removeClass(ACTIVE_MENU_ITEM);
        M_INSTANT.removeClass(ACTIVE_MENU_ITEM);
        M_CONDITIONS.removeClass(ACTIVE_MENU_ITEM);
        M_SUPPORT.removeClass(ACTIVE_MENU_ITEM);
        M_PARTNER.removeClass(ACTIVE_MENU_ITEM);
        M_DEPOSIT.removeClass(ACTIVE_MENU_ITEM);

        MM_NOTIFICATIONS.addClass(TEXT_WHITE);
        MM_NOTIFICATIONS.parent().addClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_SETTINGS.removeClass(TEXT_WHITE);
        MM_SETTINGS.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_HISTORY.removeClass(TEXT_WHITE);
        MM_HISTORY.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_INSTANT.removeClass(TEXT_WHITE);
        MM_INSTANT.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_CONDITIONS.removeClass(TEXT_WHITE);
        MM_CONDITIONS.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_SUPPORT.removeClass(TEXT_WHITE);
        MM_SUPPORT.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_PARTNER.removeClass(TEXT_WHITE);
        MM_PARTNER.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_DEPOSIT.removeClass(TEXT_WHITE);
        MM_DEPOSIT.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);

        TM_NOTIFICATIONS.addClass(TABLET_ACTIVE_MENU_ITEM);
        TM_SETTINGS.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_HISTORY.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_INSTANT.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_CONDITIONS.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_SUPPORT.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_PARTNER.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_DEPOSIT.removeClass(TABLET_ACTIVE_MENU_ITEM);
    }
    if (currentRoute === PARTNER_LINK) {
        M_PARTNER.addClass(ACTIVE_MENU_ITEM);
        M_NOTIFICATIONS.removeClass(ACTIVE_MENU_ITEM);
        M_SETTINGS.removeClass(ACTIVE_MENU_ITEM);
        M_HISTORY.removeClass(ACTIVE_MENU_ITEM);
        M_INSTANT.removeClass(ACTIVE_MENU_ITEM);
        M_CONDITIONS.removeClass(ACTIVE_MENU_ITEM);
        M_SUPPORT.removeClass(ACTIVE_MENU_ITEM);
        M_DEPOSIT.removeClass(ACTIVE_MENU_ITEM);

        MM_PARTNER.addClass(TEXT_WHITE);
        MM_PARTNER.parent().addClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_NOTIFICATIONS.removeClass(TEXT_WHITE);
        MM_NOTIFICATIONS.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_SETTINGS.removeClass(TEXT_WHITE);
        MM_SETTINGS.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_HISTORY.removeClass(TEXT_WHITE);
        MM_HISTORY.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_INSTANT.removeClass(TEXT_WHITE);
        MM_INSTANT.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_CONDITIONS.removeClass(TEXT_WHITE);
        MM_CONDITIONS.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_SUPPORT.removeClass(TEXT_WHITE);
        MM_SUPPORT.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_DEPOSIT.removeClass(TEXT_WHITE);
        MM_DEPOSIT.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);

        TM_PARTNER.addClass(TABLET_ACTIVE_MENU_ITEM);
        TM_NOTIFICATIONS.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_SETTINGS.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_HISTORY.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_INSTANT.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_CONDITIONS.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_SUPPORT.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_DEPOSIT.removeClass(TABLET_ACTIVE_MENU_ITEM);
    }

    if (currentRoute === DEPOSITS_LINK) {
        M_DEPOSIT.addClass(ACTIVE_MENU_ITEM);
        M_NOTIFICATIONS.removeClass(ACTIVE_MENU_ITEM);
        M_SETTINGS.removeClass(ACTIVE_MENU_ITEM);
        M_HISTORY.removeClass(ACTIVE_MENU_ITEM);
        M_INSTANT.removeClass(ACTIVE_MENU_ITEM);
        M_CONDITIONS.removeClass(ACTIVE_MENU_ITEM);
        M_SUPPORT.removeClass(ACTIVE_MENU_ITEM);
        M_PARTNER.removeClass(ACTIVE_MENU_ITEM);

        MM_DEPOSIT.addClass(TEXT_WHITE);
        MM_DEPOSIT.parent().addClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_NOTIFICATIONS.removeClass(TEXT_WHITE);
        MM_NOTIFICATIONS.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_SETTINGS.removeClass(TEXT_WHITE);
        MM_SETTINGS.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_HISTORY.removeClass(TEXT_WHITE);
        MM_HISTORY.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_INSTANT.removeClass(TEXT_WHITE);
        MM_INSTANT.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_CONDITIONS.removeClass(TEXT_WHITE);
        MM_CONDITIONS.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_SUPPORT.removeClass(TEXT_WHITE);
        MM_SUPPORT.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);
        MM_PARTNER.removeClass(TEXT_WHITE);
        MM_PARTNER.parent().removeClass(MOBILE_ACTIVE_MENU_ITEM);

        TM_DEPOSIT.addClass(TABLET_ACTIVE_MENU_ITEM);
        TM_NOTIFICATIONS.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_SETTINGS.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_HISTORY.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_INSTANT.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_CONDITIONS.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_SUPPORT.removeClass(TABLET_ACTIVE_MENU_ITEM);
        TM_PARTNER.removeClass(TABLET_ACTIVE_MENU_ITEM);
    }
}

export const sendPostQuery = (url, needReload = true, needResponse = true,
                              data = {}, needRedirect = false, redirectUrl = '',
                              needShowPopup = false, popupName = '', needClosePopup = false, closePopup = '') => {
    $.ajax({
        type: 'POST',
        url: url,
        data: data,
        success: function (result) {
            if (result) {
                if (!result.error) {
                    if (needResponse && result.msg) {
                        showToastNotify(TOASTR_SUCCESS, '', result.msg)
                    }
                    if (needShowPopup) {
                        if (needClosePopup) {
                            $('#' + closePopup).modal('hide')
                        }
                        $('#' + popupName).modal('show')
                    }
                    if (needReload) {
                        window.setTimeout(function () {
                            location.reload()
                        }, 3000);
                    }
                    if (needRedirect) {
                        location.href = redirectUrl;
                    }
                } else {
                    if (result.popup) {
                        $('#' + result.popup).modal('show')
                    } else {
                        if (result.msg) {
                            showToastNotify(TOASTR_ERROR, '', result.msg)
                        }
                    }
                }
            }
        }
    });
}

const sendSupportEmail = () => {
    const sendSupportAct = $('#sendSupportMessage')
    let formData = new FormData();
    const message = $('#message-support').val();
    const supportUrl = '/support';
    const uploadFile = $('#support-file')[0].files[0];
    formData.append('file', uploadFile);
    formData.append('message', message);
    sendSupportAct.prop('disabled', true);

    $.ajax({
        url: supportUrl,
        method: 'POST',
        data: formData,
        async: false,
        cache: false,
        contentType: false,
        processData: false,
        dataType: 'json',
        success: function (res) {
            let msg = res.msg
            if (msg) {
                if (res.error) {
                    showToastNotify(TOASTR_ERROR, '', msg)
                    sendSupportAct.prop('disabled', false);
                } else {
                    showToastNotify(TOASTR_SUCCESS, '', msg)
                }
            }
            window.setTimeout(function () {
                location.reload()
            }, 2000);
        }
    })
}

export const showToastNotify = (type, title, message) => {
    if (type === TOASTR_INFO) {
        toastr.info(message, title)
    }
    if (type === TOASTR_ERROR) {
        toastr.error(message, title)
    }
    if (type === TOASTR_SUCCESS) {
        toastr.success(message, title)
    }
}

const loanHistory = () => {
    location.href = '/loan-history'
}

const balanceHistory = () => {
    location.href = '/balance-history'
}

const accountSettings = () => {
    location.href = '/account-settings'
}

const authHistory = () => {
    location.href = '/authorization-history'
}

const notifications = () => {
    markMessagesRead();
    location.href = '/notifications'
}

const instantPage = () => {
    location.href = '/instant'
}

const helpPage = () => {
    window.location.href = '/help'
}

const loanTerms = () => {
    location.href = '/loan-terms'
}

const depositTerms = () => {
    location.href = '/deposit-terms'
}

const copyToClipboard = (elementId) => {
    const copyText = document.getElementById(elementId);
    copyText.disabled = false;
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    document.execCommand("copy");
}

const openInWallet = (addrElementId, amountElementId) => {
    const btcAddr = document.getElementById(addrElementId);
    const btcAmount = document.getElementById(amountElementId);
    const btcAddrValue = btcAddr.value;
    const btcAmountValue = btcAmount.value;
    const walletHref = 'bitcoin:' + btcAddrValue + '?amount=' + btcAmountValue;
    window.open(walletHref, '_blank');
}

const updateLocale = (locale, type = 'main') => {
    $.cookie('locale', locale);
    location.reload();
}

const showAuthLocaleInfo = (locale, pathname = '') => {
    if (locale === EN_LOCALE) {
        let mechanicLink = 'https://support.biterest.com/full-loan-terms-of-biterest'
        document.getElementById('auth-locale-flag').setAttribute('src', EN_FLAG)
    }
    if (locale === RU_LOCALE) {
        let mechanicLink = 'https://support.biterest.com/polnye-usloviya-biterest'
        document.getElementById('auth-locale-flag').setAttribute('src', RU_FLAG)
    }
}

export const getCurrentLocale = () => {
    return $.cookie('locale');
}

const defaultLocale = () => {
    let locale = getCurrentLocale();
    if (locale) {
        const pathname = window.location.pathname;
        if (pathname === '/sign-in' || pathname === '/sign-up' || pathname === '/recovery-password') {
            showAuthLocaleInfo(locale, pathname)
        }
    }
}

const mcLoanRepay = () => {
    $('#highRiskMarginCall').modal('hide')
    $('#loanRepayment').modal('show')
}

const mcAddFunds = () => {
    $('#highRiskMarginCall').modal('hide')
    $('#refill').modal('show')
}

const refillOpen = (modalClose) => {
    if (modalClose) {
        $('#' + modalClose).modal('hide');
        $('#refill').modal('show');
    } else {
        location.href = '/instant#refill'
    }
}

const hideTabletMenu = () => {
    $('#collapseMenuTablet').collapse('hide')
    $('#sidebar-tablet-menu').removeClass(NON_VISIBLE);
}

const showTabletCollapseMenu = () => {
    $('#collapseMenuTablet').collapse('show')
    $('#sidebar-tablet-menu').addClass(NON_VISIBLE);
}

export const checkSymbols = (elementId) => {
    const input = document.getElementById(elementId);
    const pattern = /^\d+(\.?)\d*$/g;
    const allowedCodes = [48, 49, 50, 51, 52, 53, 54, 56, 57, 190];
    input.addEventListener('input', onInput);

    function onInput(e) {
        const value = this.value;
        if (!(value.match(pattern) || allowedCodes.some(code => code === e.keyCode))) {
            this.value = value.slice(0, -1);
        }
    }
}

export const checkAmountRegexExp = (amount) => {
    const checkAmountRegexExp = /^([0]?)([.]?)([0-9]{1,}?)$/;
    const checkAmountRegex = checkAmountRegexExp.exec(amount)
    if (checkAmountRegex) {
        if (!checkAmountRegex[2]) {
            const zeroPart = checkAmountRegex[1]
            if (zeroPart) {
                let fractionPart = checkAmountRegex[3]
                if (fractionPart.length > 8) {
                    fractionPart = fractionPart.slice(0, 8);
                }
                return zeroPart + '.' + fractionPart;
            }
            return false;
        }
        return false;
    }
    return false;
}

export const checkAmountLengthRegexExp = (amount) => {
    const checkAmountLengthRegexExp = /^([0-9]{1}?)([.]?)([0-9]{1,}?)$/;
    const checkAmountLengthRegex = checkAmountLengthRegexExp.exec(amount)
    if (checkAmountLengthRegex) {
        let fraction = checkAmountLengthRegex[3]
        const unit = checkAmountLengthRegex[1]
        const point = checkAmountLengthRegex[2]
        if (fraction.length > 8 && point) {
            const validFractionPart = fraction.slice(0, 8);
            return unit + point + validFractionPart
        }
        return false;
    }
    return false;
}

const needOpenModal = () => {
    if (location.hash === '#refill') {
        window.setTimeout(function () {
            $('#refill').modal('show')
        }, 2000);
    }
}

export const parseStringFloat = (value) => {
    return parseFloat(value.replace(',', '.'));
}

const generateQrCode = (elementId, operation, qrBlock = '', qrAddrSelector = null) => {
    let QRCode = require('qrcode');
    const addr = document.getElementById(elementId);
    const addrValue = addr.value;
    if (operation === 'refill') {
        const addFundsQrCodeBlock = $('#' + qrBlock)
        if (addFundsQrCodeBlock.hasClass(NON_VISIBLE)) {
            addFundsQrCodeBlock.removeClass(NON_VISIBLE);
        } else {
            addFundsQrCodeBlock.addClass(NON_VISIBLE);
        }
        QRCode.toDataURL(addrValue, function (err, url) {
            document.getElementById(qrAddrSelector).setAttribute('src', url);
        })
    } else if (operation === 'repayment') {
        const repaymentQrCodeBlock = $('#repay-qr-code-url')
        if (repaymentQrCodeBlock.hasClass(NON_VISIBLE)) {
            repaymentQrCodeBlock.removeClass(NON_VISIBLE);
        } else {
            repaymentQrCodeBlock.addClass(NON_VISIBLE);
        }
        QRCode.toDataURL(addrValue, function (err, url) {
            document.getElementById('wallet-addr-qr-code').setAttribute('src', url);
        })
    }
    else if (operation === 'depositRefill') {
        const drQrCodeBlock = $('#dr-qr-code-url')
        if (drQrCodeBlock.hasClass(NON_VISIBLE)) {
            drQrCodeBlock.removeClass(NON_VISIBLE);
        } else {
            drQrCodeBlock.addClass(NON_VISIBLE);
        }
        QRCode.toDataURL(addrValue, function (err, url) {
            document.getElementById('dr-addr-qr-code').setAttribute('src', url);
        })
    }
}

const checkNeedShowBlockAccountPopup = () => {
    const checkShowInCookie = $.cookie('need_show_blocked');
    if (checkShowInCookie && checkShowInCookie === '1') {
        $('#accountBlocked').modal('show')
        setShowBlockedModal();
    }
}

const setShowBlockedModal = () => {
    $.cookie('need_show_blocked', false);
}

const showCancelRequestModal = () => {
    $('#cancelRequest').modal('show')
}

const showInstallModal = () => {
    const pwaModalNeedShow = checkAppInstall()
    if (pwaModalNeedShow === 'true' || location.pathname !== '/instant') {
        return;
    }

    const installModal = $('#installPwaModal')
    const device = getMobileOperatingSystem()
    if (device === 'Android' || device === 'iOS') {
        if (device === 'Android') {
            $('#android-device-pwa').removeClass('d-none')
        }
        if (device === 'iOS') {
            $('#ios-device-pwa').removeClass('d-none')
        }
        pwaSetInstall()
        installModal.modal('show')
    }
}

const hideInstallModal = () => {
    const installModal = $('#installPwaModal')
    installModal.modal('hide')
}

const getMobileOperatingSystem = () => {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "unknown";
}

const checkAppInstall = () => {
    return window.localStorage.getItem('pwa-i');
}

const pwaSetInstall = () => {
    window.localStorage.setItem('pwa-i', 'true');
}

function showSupportPopup() {
    $('#supportModal').modal('show')
}

function faqShowMore(blockId = 1) {
    const faqAddBlock = $('#faq-additionally-' + blockId);
    const faqShowMoreBtn = $('#faq-show-more-' + blockId);
    faqAddBlock.removeClass(NON_VISIBLE)
    faqShowMoreBtn.addClass(NON_VISIBLE)
}

function showFileName() {
    const uploadFileBlock = $('#support-file')
    let fileName = uploadFileBlock[0].files[0].name;
    $('#upload-file-name').text(fileName)
}

function requestCode() {
    const requestCodeBox = $('#request-code-box')
    const unlockCodeConfirmBox = $('#unlock-code-confirm-box')

    $.ajax({
        url: '/unlock-code',
        method: 'POST',
        async: false,
        dataType: 'json',
        success: function (res) {
            let msg = res.msg
            if (msg) {
                if (res.error) {
                    showToastNotify(TOASTR_ERROR, '', msg)
                } else {
                    requestCodeBox.addClass(NON_VISIBLE)
                    unlockCodeConfirmBox.removeClass(NON_VISIBLE)
                }
            }
        }
    })
}

function unlockConfirm() {
    const unlockCodeBox = $('#account-unlock-code')
    const unlockCode = unlockCodeBox.val();
    if (!unlockCode) {
        unlockCodeBox.addClass('error-input-group')
    } else {
        const data = {
            'unlock-code': unlockCode
        };
        sendPostQuery('/unlock-account', true, false, data, false, '',
            true, 'unlockAccount', true, 'accountBlocked');
    }
}

function showBotNotification() {
    $('#botModal').modal('show')
}

function setBotPopupShow() {
    const disablePopupShow = $('#disable_bot_popup_show').prop('checked');
    const data = {
        'disablePopupShow': disablePopupShow
    };
    sendPostQuery('/set-bot-popup-show', false, false, data);
    $('#botModal').modal('hide')
}

$(document).ready(() => {
    defaultLocale();
    menuCurrentLink();
    needOpenModal();
    $('[data-toggle="tooltip"]').tooltip();
    if (window.location.pathname === '/instant') {
        checkNeedShowBlockAccountPopup();
    }
})

$(document).on('click', function (e) {
    let menuOpened = $('#mobile-sidebar').hasClass('show');
    if (!$(e.target).closest('#mobile-sidebar').length &&
        !$(e.target).is('#mobile-sidebar') &&
        menuOpened === true) {
        $('#mobile-sidebar').collapse('toggle');
    }
});

function depositHistory() {
    location.href = '/deposit-history'
}

function toDepositPage() {
    location.href = '/deposits'
}

window.sendSupportEmail = sendSupportEmail;
window.loanHistory = loanHistory;
window.balanceHistory = balanceHistory;
window.accountSettings = accountSettings;
window.authHistory = authHistory;
window.instantPage = instantPage;
window.notifications = notifications;
window.copyToClipboard = copyToClipboard;
window.openInWallet = openInWallet;
window.updateLocale = updateLocale;
window.helpPage = helpPage;
window.mcLoanRepay = mcLoanRepay;
window.mcAddFunds = mcAddFunds;
window.hideTabletMenu = hideTabletMenu;
window.showTabletCollapseMenu = showTabletCollapseMenu;
window.refillOpen = refillOpen;
window.generateQrCode = generateQrCode;
window.hideInstallModal = hideInstallModal;
window.pwaSetInstall = pwaSetInstall;
window.showCancelRequestModal = showCancelRequestModal;
window.showSupportPopup = showSupportPopup;
window.faqShowMore = faqShowMore;
window.showFileName = showFileName;
window.requestCode = requestCode;
window.unlockConfirm = unlockConfirm;
window.showBotNotification = showBotNotification;
window.setBotPopupShow = setBotPopupShow;
window.depositHistory = depositHistory;
window.loanTerms = loanTerms;
window.depositTerms = depositTerms;
window.toDepositPage = toDepositPage;
